export const ReturnSource = Object.freeze({
  SelfService: 'self-service',
  RateBrowser: 'rate-browser',
  Manual: 'manual',
  IncludedInOutbound: 'included-in-outbound',
});

export type ReturnSourceType = (typeof ReturnSource)[keyof typeof ReturnSource];
